import { render } from "./SliderVerify.vue?vue&type=template&id=74781ffc&scoped=true"
import script from "./SliderVerify.vue?vue&type=script&lang=js"
export * from "./SliderVerify.vue?vue&type=script&lang=js"

import "./SliderVerify.vue?vue&type=style&index=0&id=74781ffc&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74781ffc"]])

export default __exports__